<template>
  <div v-if="hasExchangeCars">
    <dl class="financial-overview-exchange-car__summary">
      <dt v-if="!isMargeCar" class="financial-overview-exchange-car__summary-intro">
        {{ i18n.t('/FinancialOverview/Exchange Car/Warning') }}
      </dt>

      <template v-for="exchangeCar in exchangeCars" :key="exchangeCar">
        <dt class="text-value">
          {{ i18n.t('/FinancialOverview/Exchange Car/License Plate Label') }}
        </dt>
        <dd class="text-value">{{ exchangeCar.licensePlate }}</dd>

        <dt class="text-value">
          {{ i18n.t('/FinancialOverview/Exchange Car/Type Label') }}
        </dt>
        <dd class="text-value">{{ exchangeCar.typeCar }}</dd>

        <dt>
          {{ i18n.t('/FinancialOverview/Exchange Car/Exchange Value Label') }}
        </dt>
        <dd>{{ i18n.n(exchangeCar.tradeInValue, 'currency') }}</dd>

        <template v-if="!isMargeCar">
          <dt>{{ i18n.t('/FinancialOverview/Exchange Car/Vat Label') }}</dt>
          <dd>{{ i18n.n(exchangeCar.Price.Btw, 'currency') }}</dd>

          <dt>
            {{ i18n.t('/FinancialOverview/Exchange Car/Bpm Rest Value Label') }}
          </dt>
          <dd>{{ i18n.n(exchangeCar.ResidualBpm, 'currency') }}</dd>

          <dt>{{ i18n.t('/FinancialOverview/Exchange Car/Trade In Value') }}</dt>
          <dd>{{ i18n.n(exchangeCar.Price.Excl, 'currency') }}</dd>
        </template>
      </template>
    </dl>
  </div>
</template>

<script>
import StoreConnector from '@/helpers/StoreConnector'

export default {
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      exchangeCars: null,
    }
  },
  computed: {
    hasExchangeCars() {
      return this.exchangeCars?.filter((car) => car.ModelName != null).length > 0
    },
    isMargeCar() {
      return this.exchangeCars?.[0].type === 'MARGE'
    },
    typeCar() {
      return this.exchangeCars?.[0].type === 'MARGE' ? 'MARGE' : 'BTW'
    },
  },
  created() {
    StoreConnector.get('quote/exchangeCars', (data) => {
      this.exchangeCars = data?.map((car) => {
        car.licensePlate = car?.LicensePlate
        car.type = car?.Type
        car.tradeInValue = Number(car?.TradeValue || 0)
        return car
      })
    })
  },
}
</script>

<style lang="scss" scoped>
.financial-overview-exchange-car {
  &__summary {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 1rem;
    padding-left: 1rem;

    > dt {
      flex-grow: 1;
      width: 80%;
    }

    > dd {
      width: 20%;
    }

    &-intro {
      font-style: italic;
    }

    dt.text-value {
      width: 70%;
    }
    dd.text-value {
      width: 30%;
    }
  }
}
</style>
